import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User opened boards following modal',
  name: 'opened_boards_following_modal',
};

export default META;
